import ProjectType1 from './project-type-1/project-type-1.vue'; // 耕地类型地块信息
import ProjectType2 from './project-type-2/project-type-2.vue'; // 林地
import ProjectType3 from './project-type-3/project-type-3.vue'; // 水面
import ProjectType4 from './project-type-4/project-type-4.vue'; // 四荒
import ProjectType6 from './project-type-6/project-type-6.vue'; // 房屋
import ProjectType7 from './project-type-7/project-type-7.vue'; // 设备设施
import ProjectType8 from './project-type-8/project-type-8.vue'; // 综合类

export default {
  components: {
    ProjectType1,
    ProjectType2,
    ProjectType3,
    ProjectType4,
    ProjectType6,
    ProjectType7,
    ProjectType8
  },
  props: {
    projectInfo: {
      type: Object,
      default: {}
    },
    bidInfo: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
    };
  },
  created () {
  },
  computed: {
    projectType () {
      return this.projectInfo && this.projectInfo.projectType;
    },
    projectSubType () {
      return this.projectInfo && this.projectInfo.projectSubType;
    },
    assetsArr () {
      if (this.bidInfo) {
        const lands = this.bidInfo.detail.map(item => {
          if (item.assetsInfo) {
            item = {
              ...item,
              ...JSON.parse(item.assetsInfo)
            };
          }
          return item;
        });
        return lands;
      } else {
        return [];
      }
    }
  },
  methods: {
  }
};
